import { useEffect, useMemo, useState } from "react";
import axios from "../../../api/axios";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import DataTable from "examples/Tables/DataTable";

export default function VariationReports() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const [effectiveMonth, setEffectiveMonth] = useState("");
  const [variationType, setVariationType] = useState("");
  const [pfNo, setPfNo] = useState("");
  const [status, setStatus] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/variation-reports", {
        params: {
          effective_month: effectiveMonth || undefined,
          variation_type: variationType || undefined,
          pf_no: pfNo || undefined,
          status: status || undefined,
          per_page: 200,
        },
      });
      setRows(res.data?.data || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const exportCsv = async () => {
    const res = await axios.get("/variation-reports/export.csv", {
      params: {
        effective_month: effectiveMonth || undefined,
        variation_type: variationType || undefined,
        pf_no: pfNo || undefined,
        status: status || undefined,
      },
      responseType: "blob",
    });

    const blob = new Blob([res.data], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "variation_reports.csv";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  const columns = useMemo(
    () => [
      { Header: "Batch", accessor: "batch_ref" },
      { Header: "PF No", accessor: "pf_no" },
      { Header: "Name", accessor: "staff_name" },
      { Header: "Type", accessor: "variation_type" },
      { Header: "Month", accessor: "effective_month" },
      { Header: "Status", accessor: "status" },
      { Header: "Row", accessor: "source_row" },
      { Header: "Error", accessor: "validation_error" },
    ],
    []
  );

  return (
    <MDBox p={3}>
      <MDTypography variant="h5">Variation Reports</MDTypography>
      <MDTypography variant="button" color="text">
        View variations by month, type, staff, and status. Export monthly audit reports.
      </MDTypography>

      <MDBox mt={3} p={2} sx={{ border: "1px solid #eee", borderRadius: 2 }}>
        <MDBox display="flex" gap={2} flexWrap="wrap" alignItems="center">
          <MDBox width={180}>
            <MDInput
              label="Month (YYYY-MM)"
              value={effectiveMonth}
              onChange={(e) => setEffectiveMonth(e.target.value)}
            />
          </MDBox>

          <MDBox width={220}>
            <MDInput
              label="Variation Type"
              value={variationType}
              onChange={(e) => setVariationType(e.target.value)}
            />
          </MDBox>

          <MDBox width={160}>
            <MDInput label="PF No" value={pfNo} onChange={(e) => setPfNo(e.target.value)} />
          </MDBox>

          <MDBox width={160}>
            <MDInput label="Status" value={status} onChange={(e) => setStatus(e.target.value)} />
          </MDBox>

          <MDButton color="info" onClick={load} disabled={loading}>
            {loading ? "Loading..." : "Load"}
          </MDButton>

          <MDButton color="secondary" onClick={exportCsv} disabled={loading}>
            Export CSV
          </MDButton>
        </MDBox>
      </MDBox>

      <MDBox mt={3}>
        <DataTable
          table={{ columns, rows }}
          entriesPerPage={false}
          showTotalEntries={false}
          canSearch
          pagination
          noEndBorder
        />
      </MDBox>
    </MDBox>
  );
}
